import React from 'react'

const Editor = () => {
  return (
    <div>
      
    </div>
  )
}

export default Editor
